import { css } from 'styled-components';
import { regularWhite, fontWeightRegular } from '../design-tokens';

export const toRem = (property: string, sizeValue: number): string => `
    ${property}: ${sizeValue * 10}px;
    ${property}: ${sizeValue}rem;
`;

export const playFontSize = (sizeValue = 1): string => `
    ${toRem('font-size', sizeValue)}
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
`;

export const regularOutline = (offset = 0, color = regularWhite) => css`
    outline: ${color} solid 2px;
    outline-offset: ${offset}px;
`;

export const playFontIcon = (sizeValue = 1, icon = ''): string => `
    font-family: svt-icons;
    ${toRem('font-size', sizeValue)}
    display: inline-block;
    vertical-align: middle;
    line-height: 1;
    font-weight: ${fontWeightRegular};
    font-style: normal;
    speak: none;
    text-decoration: inherit;
    text-transform: none;
    -webkit-font-smoothing: antialiased;
    content: '${icon}';
`;
